import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="p-5">
      <Container>
        <p>
          Reportajes elaborados con el apoyo financiero del <a
            href="https://forest-trends.org/infraestructura-natural-en-peru/"
            target="_blank"
            rel="noreferrer"
          >Proyecto
          Infraestructura Natural para la Seguridad Hídrica (INSH)</a>, a partir de
          la participación de los autores en el “Programa de Capacitación de
          Periodistas: En Busca de la Sostenibilidad para la Seguridad Hídrica”,
          implementado en alianza con la <a
            href="https://fundacionmohme.org/"
            target="_blank"
            rel="noreferrer"
          >Fundación Gustavo Mohme Llona</a>.
        </p>
        <p>
          El proyecto INSH es promovido y financiado por la Agencia de los
          Estados Unidos para el Desarrollo Internacional (USAID) y el Gobierno
          de Canadá, y liderado por Forest Trends junto a sus socios Condesan,
          SPDA, EcoDecisión y el Imperial College de Londres.
        </p>
        <div>
          <p>
            Coordinación periodística: Wilber Huacasi
            <br />
            Asesoría: Edmundo Cruz y Mario Munive
            <br />
            Desarrollo web: Melissa Chávez
          </p>
        </div>
        <p>2021 - 2022</p>
      </Container>
    </footer>
  );
};

export default Footer;
